import { Grid, Tooltip, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { IComponentCss } from '../styles';

type VerticalTabLabelProps = {
    title: string | number | ReactElement,
    subTitle: string | number | ReactElement,
    chipLabel?: string | number | ReactElement,
    chipTooltipLabel?: string | number | ReactElement,
}


const css: IComponentCss = {
    wrap: {
        alignItems: 'flex-start',
        width: '100%',
        textAlign: 'left',
        padding: '12px 16px',
        textTransform: 'none',
        fontWeight: 700,
        borderBottom: '1px solid #E0E0E0',
    },
    title: {
        lineHeight: 1.6,
        fontWeight: 700,
        color: '#212121 !important',
    },
    chipLabel: {
        lineHeight: 1.6, color: '#999999 !important', fontSize: '12px', paddingTop: '3px',
    },
    subTitle: {
        lineHeight: 1.3, color: '#999999 !important', fontSize: '12px',
    },
};

export const VerticalTabLabel = ({
    title,
    subTitle,
    chipLabel,
    chipTooltipLabel,
}: VerticalTabLabelProps): ReactElement => {
    return (
        <Grid container sx={css.wrap} >
            <Grid
                container
                alignContent='space-between'
                justifyContent='space-between'
            >
                {/* Заголовок таба */}
                <Typography sx={css.title}>
                    {title}
                </Typography>

                {/* Чип (метка) таба */}
                {chipLabel && chipTooltipLabel &&
                    <Tooltip title={<>{chipTooltipLabel}</>}>
                        <Typography sx={css.chipLabel}>
                            {chipLabel}
                        </Typography>
                    </Tooltip>
                }
            </Grid>

            {/* Подзаголовок таба */}
            <Typography sx={css.subTitle}>
                {subTitle}
            </Typography>
        </Grid>
    )
}